module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "overview",
    attrs: {
      "id": "overview"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c1 col-md-12"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "overview-tab-2"
    }
  }, [_c('div', {
    staticClass: "r1 row"
  }, [_c('div', {
    staticClass: "c2 col-sm-6 col-md-6 animateblock ltr-2 speed-3"
  }, [_c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-1"
  }, [_c('User')], 1), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-2"
  }, [_c('File')], 1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-3"
  }, [_c('Chat')], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('div', {
    staticClass: "c3 col-sm-6 col-md-6 animateblock rtl-2 speed-3"
  }, [_c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-4"
  }, [_c('Block')], 1), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-5"
  }, [_c('Doc')], 1), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('div', {
    staticClass: "overview-wrapper"
  }, [_c('div', {
    staticClass: "hidden-sm overview-icon ico-6"
  }, [_c('Search')], 1), _vm._v(" "), _vm._m(6)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-header"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("Возможности")]), _vm._v(" "), _c('h3', {
    staticClass: "section-subtitle"
  }, [_vm._v("\n                Плюс ко всему у нас есть весь стандартный набор функций")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Вид для клиента")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            У нас предусмотрена возможность организовать вход для клиентов в конкретные проекты, для показа процесса работы и статуса задач. Только то что вы хотите показывать, без вмешательства клиента в ваши внутренние процессы.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Логирование ")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Ведем историю всех действий всех пользователей по задачам и таскам. Всегда легко найти когда, что и кем было сделано по проекту.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Комментарии")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Что-то непонятно по задаче и нужно уточнить? Удобное обсуждение задач прямо в теле задачи. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Безопасность")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Используем SSL, SHA256 шифрование и шифрование БД, так что никто кроме вас не получит доступа к вашим данным.\n                                            Возможность назначить разный набор прав разным группам и индивидуально пользователям")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Файлы")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Возможность прикреплять файлы как для хранения в облаке самого трекера, так и указывать внешние ссылки. Доступ к файлам как приватный так и общий.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overview-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("Поиск")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("\n                                            Умный контекстный поиск с набором настроек для получения точного результата")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3342c217","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Overview.vue
// module id = 1230
// module chunks = 1